import { render, staticRenderFns } from "./CustomDate.vue?vue&type=template&id=60a2b7ee&scoped=true"
import script from "./CustomDate.vue?vue&type=script&lang=js"
export * from "./CustomDate.vue?vue&type=script&lang=js"
import style0 from "./CustomDate.vue?vue&type=style&index=0&id=60a2b7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2b7ee",
  null
  
)

export default component.exports